
import $ from 'jquery';
import template from 'common-views/select-start-page.ejs';
import constants from 'Constants';
import SettingsModalBase from 'common-views/SettingsModalBase';

class StartPageSettingModal extends SettingsModalBase {

    initialize( opts ){
        super.initialize( opts );

        this.template = template;
        this.defaultValue = opts.defaultValue || "default";
        this.title = opts.title || 'Edit Start Page';

        this.pages = this.initPages(opts.currentPages || []);

        this.initMap();
        this.initModel();

        $('body').append(this.$el);
    }

    setNewValue( newValue ) {
        this.model.set('startPage', newValue);
    }

    initPages(currentPages) {
        const pages = _.clone(constants.START_PAGE_OPTIONS);
        currentPages.forEach(p => pages.push( {label: p.model.get('name'), value: p.model.get('id'), altValue: p.model.get('altId') }) );
        return pages;
    }

    triggerUpdate( ) {
        this.model.trigger(constants.EV_START_PAGE_SETTINGS_UPDATED);
    }

    initModel(){
        super.initModel();
        this.model.set('pages', this.pages, constants.MODEL_SILENT);
    }

}

export default StartPageSettingModal;
